<div class="container">
  <p class="title">Vessel Specific Data</p>
  <!-- <div class="text-right">
    <button class="btn btn-light hover-button mail">
      <mat-icon>clear_all</mat-icon> &nbsp;Clear
    </button>
    <button class="btn btn-light hover-button mail">
      <mat-icon>done</mat-icon> Submit
    </button>
  </div> -->
  <div class="bgv">
    <form [formGroup]="settingForm">
      <div formArrayName="maneuvering">
        <div
          class="row"
          *ngFor="let group of maneuvering.controls; let i = index"
          [formGroupName]="i"
        >
          <div class="col-md-1">
            <label class="mLabels">Maneuvering</label>
            <!-- <app-custom-input
            [controlname]="this.settingForm.controls['maneuvering']"
          ></app-custom-input> -->
          </div>
          <div class="col-md-4">
            <label class="labels">ME Consumption(mt/day)</label>
            <app-custom-input
              [controlname]="group.get('meConsumption')"
            ></app-custom-input>
          </div>

          <div class="col-md-4">
            <label class="labels">Aux Engine(mt/day)</label>
            <app-custom-input
              [controlname]="group.get('auxEngine')"
            ></app-custom-input>
          </div>

          <div class="col-md-2">
            <label class="labels">Aux Boiler(mt/day)</label>
            <app-custom-input
              [controlname]="group.get('auxBoiler')"
            ></app-custom-input>
          </div>
        </div>
      </div>
      <div formArrayName="foLaden">
        <div
          class="row rowBgv"
          *ngFor="let group of foLaden.controls; let i = index"
          [formGroupName]="i"
        >
          <div class="col-md-1">
            <label class="mLabels">FO Laden</label>
            <!-- <app-custom-input [controlname]="group.get('foLaden')"></app-custom-input> -->
          </div>

          <div class="col-md-2">
            <label class="labels">Speed(knots)</label>
            <app-custom-input
              [controlname]="group.get('speed')"
            ></app-custom-input>
          </div>

          <div class="col-md-2">
            <label class="labels">ME Consumption(mt/day)</label>
            <app-custom-input
              [controlname]="group.get('meConsumption')"
            ></app-custom-input>
          </div>

          <div class="col-md-2">
            <label class="labels">Aux Engine(mt/day)</label>
            <app-custom-input
              [controlname]="group.get('auxEngine')"
            ></app-custom-input>
          </div>

          <div class="col-md-2">
            <label class="labels">Aux Boiler</label>
            <app-custom-input
              [controlname]="group.get('auxBoiler')"
            ></app-custom-input>
          </div>

          <div class="col-md-2">
            <label class="labels">LSMGO/MDO(mt/day)</label>
            <app-custom-input
              [controlname]="group.get('mgo')"
            ></app-custom-input>
          </div>

          <!-- Add/Remove Buttons -->
          <div class="addIcon col-md-1">
            <mat-icon
              class="add-icon"
              *ngIf="i === foLaden.length - 1 && foLaden.length < 5"
              (click)="addFoLadenRow()"
              matTooltip="Add Row"
              >add_circle_outline</mat-icon
            >

            <mat-icon
              class="remove-icon"
              *ngIf="foLaden.length > 1"
              (click)="removeFoLadenRow(i)"
              matTooltip="Remove Row"
              >remove_circle_outline</mat-icon
            >
          </div>
        </div>
      </div>

      <div formArrayName="foBallast">
        <div
          class="row rowBgv"
          *ngFor="let group of foBallast.controls; let i = index"
          [formGroupName]="i"
        >
          <div class="col-md-1">
            <label class="mLabels">FO Ballast</label>
            <!-- <app-custom-input [controlname]="group.get('foBallast')"></app-custom-input> -->
          </div>

          <div class="col-md-2">
            <label class="labels">Speed(knots)</label>
            <app-custom-input
              [controlname]="group.get('speed')"
            ></app-custom-input>
          </div>

          <div class="col-md-2">
            <label class="labels">ME Consumption(mt/day)</label>
            <app-custom-input
              [controlname]="group.get('meConsumption')"
            ></app-custom-input>
          </div>

          <div class="col-md-2">
            <label class="labels">Aux Engine(mt/day)</label>
            <app-custom-input
              [controlname]="group.get('auxEngine')"
            ></app-custom-input>
          </div>

          <div class="col-md-2">
            <label class="labels">Aux Boiler(mt/day)</label>
            <app-custom-input
              [controlname]="group.get('auxBoiler')"
            ></app-custom-input>
          </div>
          <div class="col-md-2">
            <label class="labels">LSMGO/MDO(mt/day)</label>
            <app-custom-input
              [controlname]="group.get('mgo')"
            ></app-custom-input>
          </div>

          <!-- Add/Remove Buttons -->
          <div class="addIconTwo col-md-1">
            <mat-icon
              class="add-icon"
              *ngIf="i === foBallast.length - 1 && foBallast.length < 5"
              (click)="addFoBallastRow()"
              matTooltip="Add Row"
              >add_circle_outline</mat-icon
            >

            <mat-icon
              class="remove-icon"
              *ngIf="foBallast.length > 1"
              (click)="removeFoBallastRow(i)"
              matTooltip="Remove Row"
              >remove_circle_outline</mat-icon
            >
          </div>
        </div>
      </div>

      <br />

      <br />
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-2">
          <label class="labels">Idle in Port(mt/day)</label>
          <app-custom-input
            [controlname]="this.settingForm.controls['idleInPort']"
          ></app-custom-input>
        </div>
        <div class="col-md-2">
          <label class="labels">Idle at Anchorage(mt/day)</label>
          <app-custom-input
            [controlname]="this.settingForm.controls['idleAtAnchorage']"
          ></app-custom-input>
        </div>
        <div class="col-md-2">
          <label class="labels">Loading(mt/day)</label>
          <app-custom-input
            [controlname]="this.settingForm.controls['loading']"
          ></app-custom-input>
        </div>
        <div class="col-md-2">
          <label class="labels">Discharging(mt/day)</label>
          <app-custom-input
            [controlname]="this.settingForm.controls['discharging']"
          ></app-custom-input>
        </div>
        <div class="col-md-2">
          <label class="labels">Inerting(mt/day)</label>
          <app-custom-input
            [controlname]="this.settingForm.controls['inerting']"
          ></app-custom-input>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-2">
          <label class="labels">Gas Freeing(mt/day)</label>
          <app-custom-input
            [controlname]="this.settingForm.controls['gasFreeing']"
          ></app-custom-input>
        </div>
        <div class="col-md-2">
          <label class="labels">Tank Cleaning(mt/day)</label>
          <app-custom-input
            [controlname]="this.settingForm.controls['tankCleaning']"
          ></app-custom-input>
        </div>
        <div class="col-md-2">
          <label class="labels">Maintaining Cargo Temp(mt/day)</label>
          <app-custom-input
            [controlname]="this.settingForm.controls['maintainingTemp']"
          ></app-custom-input>
        </div>
        <div class="col-md-2">
          <label class="labels">Raising Cargo Temp(mt/day)</label>
          <app-custom-input
            [controlname]="this.settingForm.controls['raisingTemp']"
          ></app-custom-input>
        </div>
      </div>
    </form>
  </div>
  <div class="text-right">
    <button class="btn btn-light hover-button mail" (click)="uploadfile()">
      <mat-icon>file_upload</mat-icon>Upload Files
    </button>
    <button class="btn btn-light hover-button mail">
      <mat-icon>clear_all</mat-icon> &nbsp;Clear
    </button>
    <button class="btn btn-light hover-button mail" (click)="submit()">
      <mat-icon>done</mat-icon> Submit
    </button>
  </div>
</div>
